import React, { useState, useRef, useEffect } from 'react';
import { motion } from 'framer-motion';
import { useAtom } from 'jotai';
import { userAtom } from '../../../../atoms/authAtoms';
import { uploadProfileImage, deleteProfileImage } from '../controller/user-controller';
import { tokenAtom } from '../../../../atoms/authAtoms';

const ProfilePicture = ({handleChange,initialData,localImage}) => {
  const [user] = useAtom(userAtom);
  const [imageHover, setImageHover] = useState(false);
  const [isUploading, setIsUploading] = useState(false);
  const [uploadError, setUploadError] = useState(null);
  const [uploadSuccess, setUploadSuccess] = useState(false);
  const fileInputRef = useRef(null);
  const [token, setToken] = useAtom(tokenAtom);
  // Get user avatar URL based on user data
  const getUserAvatar = () => {
    if (initialData?.image) {
      return initialData.image;
    }

    if (localImage) {
      return URL.createObjectURL(localImage);
    }


    // Generate a default avatar with user's initials if available
    // if (initialData && (initialData.firstName || initialData.lastName)) {
    //   const initials = `${initialData.firstName?.charAt(0) || ''}${initialData.lastName?.charAt(0) || ''}`;
    //   return `https://ui-avatars.com/api/?name=${initials}&background=174540&color=fff&size=200`;
    // }
  //  Fallback to default image
    return;

    return "https://ui-avatars.com/api/?name=User&background=174540&color=fff&size=200";
  };
  
  // Use state for image URL with the getUserAvatar function
  const [imageUrl, setImageUrl] = useState(getUserAvatar);
  
  // Update image URL when user changes
  useEffect(() => {
    setImageUrl(getUserAvatar());
  }, []);

  // Function to handle clicking the "Change photo" button
  const handleChangePhotoClick = () => {
    fileInputRef.current.click();
  };

  // Handle file selection
  const handleFileSelect = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    // Check file type
    if (!file.type.match('image.*')) {
      setUploadError("Veuillez sélectionner une image valide");
      return;
    }

    // Check file size (max 5MB)
    if (file.size > 5 * 1024 * 1024) {
      setUploadError("L'image doit être inférieure à 5 Mo");
      return;
    }

    setImageUrl(URL.createObjectURL(file));
    handleChange({
      target: {
        name: 'image',
        value: e.target.files[0],
      }})

  };

  // Handle image deletion
  const handleDeleteImage = async () => {
    setImageUrl(getUserAvatar());
    handleChange({
      target: {
        name: 'image',
        value: null,
      }})



  };

  return (
    <div className="space-y-8">
      <div>
        <h3 className="text-xl font-semibold text-gray-900 flex items-center">
          <svg className="w-5 h-5 mr-2 text-[#174540]" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"></path>
          </svg>
          Photo de profil
        </h3>
        <p className="mt-2 text-sm text-gray-500 pl-7">
          Cette photo sera affichée sur votre profil et sera visible par les autres utilisateurs.
        </p>
      </div>

      {/* Hidden file input */}
      <input 
        type="file" 
        ref={fileInputRef} 
        className="hidden" 
        accept="image/*" 
        onChange={handleFileSelect}
      />


  

      <div className="flex flex-col md:flex-row md:items-center md:space-x-10 bg-gray-50 p-6 rounded-xl border border-gray-100">
        <div 
          className="relative flex items-center  mx-auto md:mx-0 h-48 w-48 rounded-full overflow-hidden group cursor-pointer"
          onMouseEnter={() => setImageHover(true)}
          onMouseLeave={() => setImageHover(false)}
          onClick={handleChangePhotoClick}
        >
          <motion.div 
            className="absolute inset-0 bg-black bg-opacity-50 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300"
            animate={{ opacity: imageHover ? 0.7 : 0 }}
          >
            <svg className="h-10 w-10 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 9a2 2 0 012-2h.93a2 2 0 001.664-.89l.812-1.22A2 2 0 0110.07 4h3.86a2 2 0 011.664.89l.812 1.22A2 2 0 0018.07 7H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z"></path>
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 13a3 3 0 11-6 0 3 3 0 016 0z"></path>
            </svg>
          </motion.div>
          
{  imageUrl?          <img 
              src={imageUrl}
              alt="Photo de profil" 
              className="h-full w-full object-cover transition-transform duration-500 ease-out group-hover:scale-110"
              onError={(e) => {
                // Fallback if image fails to load
                e.target.src = "https://ui-avatars.com/api/?name=User&background=174540&color=fff&size=200";
              }}
            />:

            <div className={`h-32 w-32 m-auto border-2 border-dashed border-gray-300 rounded-lg flex items-center justify-center `}>
            <div
              htmlFor="product-image"
              className={`cursor-pointer flex flex-col items-center cursor-pointer`}
            >
              <svg className="h-8 w-8 text-gray-400" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
              </svg>
              <span className="mt-2 text-sm text-gray-500">
                { 'Ajouter une image'}
              </span>
            </div>
          </div>

}          
          
          <div className="absolute -bottom-1 -right-1 h-10 w-10 bg-[#174540] rounded-full flex items-center justify-center border-4 border-white shadow-md">
            <svg className="h-5 w-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 9a2 2 0 012-2h.93a2 2 0 001.664-.89l.812-1.22A2 2 0 0110.07 4h3.86a2 2 0 011.664.89l.812 1.22A2 2 0 0018.07 7H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z"></path>
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 13a3 3 0 11-6 0 3 3 0 016 0z"></path>
            </svg>
          </div>
        </div>

        <div className="flex flex-col space-y-5 mt-8 md:mt-0">
          <div className="bg-white p-4 rounded-lg shadow-sm border border-gray-100">
            <h4 className="text-sm font-medium text-gray-900 mb-2">Options de photo</h4>
            <div className="flex flex-col space-y-3">
              <motion.button
                type="button"
                whileHover={{ scale: 1.02 }}
                whileTap={{ scale: 0.98 }}
                className="inline-flex items-center px-4 py-2.5 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-gradient-to-r from-[#174540] to-[#1b534d] hover:from-[#1b534d] hover:to-[#1f6159] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#174540] transition-all duration-200"
                onClick={handleChangePhotoClick}
                disabled={isUploading}
              >
            
                  <>
                    <svg className="-ml-1 mr-2 h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                      <path fillRule="evenodd" d="M4 5a2 2 0 00-2 2v8a2 2 0 002 2h12a2 2 0 002-2V7a2 2 0 00-2-2h-1.586a1 1 0 01-.707-.293l-1.121-1.121A2 2 0 0011.172 3H8.828a2 2 0 00-1.414.586L6.293 4.707A1 1 0 015.586 5H4zm6 9a3 3 0 100-6 3 3 0 000 6z" clipRule="evenodd" />
                    </svg>
{             imageUrl     ?  'Changer la photo': 'Ajouter Photo'}            
      </>
              
              </motion.button>
{      imageUrl &&      <motion.button
                type="button"
                whileHover={{ scale: 1.02 }}
                whileTap={{ scale: 0.98 }}
                className="inline-flex items-center px-4 py-2.5 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#174540] transition-all duration-200"
                onClick={handleDeleteImage}
                disabled={isUploading}
              >
                <svg className="-ml-1 mr-2 h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z" clipRule="evenodd" />
                </svg>
                Supprimer
              </motion.button>}
            </div>
          </div>
          
          <div className="bg-gradient-to-r from-blue-50 to-indigo-50 border-l-4 border-blue-400 p-4 rounded-r-lg">
            <div className="flex">
              <div className="flex-shrink-0">
                <svg className="h-5 w-5 text-blue-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
                </svg>
              </div>
              <div className="ml-3">
                <p className="text-sm text-blue-700">
                  Une photo de profil professionnelle augmente la confiance des autres utilisateurs.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfilePicture;